import React from 'react';

import {
  Actions,
  Action,
  ExpandMoreIcon,
  ExpandLessIcon,
} from '@gogame/components';

const WidgetActions = ({
  collapsedCart,
  onChangeCollapsedCart,
  onSave,
  onReset,
  onRemove,
  loading,
  changed,
  editable,
}) => {
  return (
    <Actions limit={2}>
      <Action
        label={collapsedCart ? 'Expand' : 'Collapse'}
        onClick={onChangeCollapsedCart}
        icon={collapsedCart ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      />
      {editable ? (
        <Action
          label={'Update preset'}
          disabled={!(changed && !loading)}
          onClick={onSave}
          badge={changed}
        />
      ) : null}
      <Action
        label={'Discard changes'}
        onClick={onReset}
        disabled={!(changed && !loading)}
        badge={changed}
      />
      <Action label={'Remove widget'} onClick={onRemove} />
    </Actions>
  );
};

export default WidgetActions;
